<div if.bind="admin.isAdmin" class="admin-menu">
  <button
    class="hamburger-btn ${admin.adminMenuOpen ? 'active' : ''}"
    click.trigger="admin.toggleAdminMenu()"
    disabled.bind="calendar.loading"
    aria-label="Admin menu"
    aria-haspopup="true"
    aria-expanded.bind="admin.adminMenuOpen">
    <span class="hamburger-btn__bars"></span>
  </button>
  <div if.bind="admin.adminMenuOpen" class="admin-menu__backdrop" click.trigger="admin.closeAdminMenu()"></div>
  <div if.bind="admin.adminMenuOpen" class="admin-menu__dropdown">
    <button class="admin-menu__item ${feedback.enabled ? 'active' : ''}" click.trigger="feedback.setEnabled(!feedback.enabled)" disabled.bind="feedback.savingEnabled">
      <span class="admin-menu__icon"><span class="icon icon--info" aria-hidden="true"></span></span>
      <span>Feedback: ${feedback.enabled ? 'On' : 'Off'}</span>
    </button>
    <button class="admin-menu__item" click.trigger="openImageCache()" disabled.bind="calendar.loading">
      <span class="admin-menu__icon"><span class="icon icon--list" aria-hidden="true"></span></span>
      <span>Image cache</span>
    </button>
    <button class="admin-menu__item" click.trigger="openUsersReport()" disabled.bind="calendar.loading">
      <span class="admin-menu__icon"><span class="icon icon--list" aria-hidden="true"></span></span>
      <span>User report</span>
    </button>
    <button class="admin-menu__item" click.trigger="openAnalytics()" disabled.bind="calendar.loading">
      <span class="admin-menu__icon"><span class="icon icon--list" aria-hidden="true"></span></span>
      <span>Signup analytics</span>
    </button>
    <button class="admin-menu__item" click.trigger="openDailyReleases()" disabled.bind="calendar.loading">
      <span class="admin-menu__icon"><span class="icon icon--list" aria-hidden="true"></span></span>
      <span>Daily Releases</span>
    </button>
    <button class="admin-menu__item" click.trigger="openScraperReport()" disabled.bind="calendar.loading">
      <span class="admin-menu__icon"><span class="icon icon--list" aria-hidden="true"></span></span>
      <span>Scraper Report</span>
    </button>
    <button class="admin-menu__item" click.trigger="openConfiguration()" disabled.bind="calendar.loading">
      <span class="admin-menu__icon"><span class="icon icon--list" aria-hidden="true"></span></span>
      <span>Configuration</span>
    </button>
    <button class="admin-menu__item" click.trigger="openLogs()" disabled.bind="calendar.loading">
      <span class="admin-menu__icon"><span class="icon icon--list" aria-hidden="true"></span></span>
      <span>Logs</span>
    </button>
    <button if.bind="!account.isAuthenticated" class="admin-menu__item" click.trigger="admin.logout()" disabled.bind="calendar.loading">
      <span class="admin-menu__icon"><span class="icon icon--signout" aria-hidden="true"></span></span>
      <span>Sign out</span>
    </button>
  </div>
</div>
